// extracted by mini-css-extract-plugin
var _1 = "theme-provider-module__theme-default__Gk8tE";
var _2 = "theme-provider-module__themeProvider__ZBoeW";
export { _1 as "theme-default", _2 as "themeProvider" }
export default { "theme-default": _1, "themeProvider": _2 }
